// Globals
import { MenuProps } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';

// Modules
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { StyledMenu, StyledPageTitle, StyledPageWrapper } from '../../components/Styled';
import { StyledHeaderWrapper } from './FeedbacksContainerStyles';

// Helpers
import { FeedbackTabs, getTabsConfig } from '../../helpers/configs';
import { selectNewFeedbacksCountByType } from '../../feature';

const FeedbacksContainer = () => {
  const { t } = useTranslation(['feedbacks']);
  const { canManage } = usePermissions();
  const newCountByType = useAppState(selectNewFeedbacksCountByType);
  const canManageFeedback = canManage(Resource.FEEDBACK);
  const tabsConfig = useMemo(
    () => getTabsConfig(t, newCountByType, canManageFeedback),
    [t, newCountByType, canManageFeedback],
  );
  const [selectedKey, setSelectedKey] = useState(tabsConfig[0].key);

  const selectedTab = useMemo(() => tabsConfig.find((item) => item.key === selectedKey), [selectedKey, tabsConfig]);

  const onMenuButtonClick: MenuProps['onClick'] = (e) => {
    const newTab = e.key as FeedbackTabs;
    setSelectedKey(newTab);
  };

  return (
    <StyledPageWrapper>
      <StyledHeaderWrapper>
        <StyledPageTitle>{t('page_title')}</StyledPageTitle>
        <StyledMenu
          mode="horizontal"
          items={tabsConfig}
          defaultSelectedKeys={[selectedKey]}
          selectedKeys={[selectedKey]}
          onClick={onMenuButtonClick}
        />
      </StyledHeaderWrapper>

      {selectedTab?.content}
    </StyledPageWrapper>
  );
};

export default FeedbacksContainer;
